import React, { useState } from 'react'
import './form.css'
import emailjs from '@emailjs/browser';

export default function Container8() {
  const[input,setInput]=useState({
  name:"",
  email:'',
  number:'',
  your_message:'',
  Google_Suche:'',
  Instagram:'',
  Facebook:'',
  LinkedIN:'',
  Youtube:'',
  durch_Freunde:'',
  durch_die_Pii_Screens:'',
  });
   
const send =(e)=>{
  e.preventDefault();
emailjs.sendForm('service_k9m3uc7','template_7gwkjvj',e.target,'nuIOLaPIuBKgkWFUo');
alert("submitted");
setInput({
  name:"",
  email:'',
  number:'',
  your_message:'',
  Google_Suche:'',
  Instagram:'',
  Facebook:'',
  LinkedIN:'',
  Youtube:'',
  durch_Freunde:'',
  durch_die_Pii_Screens:'',
})
}
  return (
    <>
    <div className='py-5'>
    <div className='container my-5'>
        <h3 className='fw-bold'>Schluss mit den Ausreden</h3>
        <h1 className='fw-bold'>Katapultiere deine  Werbung auf<span className='text-success1'> das nächste Level</span></h1>
        
        <div className='row mx-auto text-center '>
          <h2 className='hcolor my-5 py-3'>Kontaktformular</h2>
          <h4 className='formhd mb-5 pyb-3'>Hast du Fragen?<br/>
Wir freuen uns auf deine Nachricht und setzen uns so schnell wie möglich mit dir in Verbindung.</h4>
            <form className='border py-2' onSubmit={send}>
              <h5 className='formhd mt-3'>Name<span className='text-danger'>*</span></h5>
              <input type="text" required className='w-100   border mb-3 text-center' name='name' maxLength={20} value={input.name} onChange={(e)=>setInput({...input,[e.target.name]:e.target.value})}/>
              <h5 className='formhd mt-3'>Email<span className='text-danger'>*</span></h5>
              <input type="email" required className='w-100 border rounded-2 mb-3 text-center' name='email' value={input.email} onChange={(e)=>setInput({...input,[e.target.name]:e.target.value})}/>
              <h5 className='formhd mt-3'>Telefon</h5>
              <input type="number" className='w-100 border rounded-2 mb-3 text-center'  name='number' value={input.number}  onChange={(e)=>setInput({...input,[e.target.name]:e.target.value})}/>
              <h5  className='formhd mt-3'>Deine Nachricht<span className='text-danger'>*</span></h5>
              <textarea type="text" required className='w-100 border rounded-2 mb-3 text-center' name='your_message' maxLength={200} value={input.your_message} onChange={(e)=>setInput({...input,[e.target.name]:e.target.value})}/>
              <h5 className='fornhd mt-3'>Wie hast du von uns erfahren?</h5>
              <input type="checkbox" id="Google-Suche" name="Google-Suche" value="Google-Suche" className=' checkbox' onChange={(e)=>setInput({...input,[e.target.name]:e.target.value})}/>
              <label for="select" className='me-2'> Google-Suche</label>
              <input type="checkbox" id="Instagram" name="Instagram" value="instagram" className=' checkbox' onChange={(e)=>setInput({...input,[e.target.name]:e.target.value})}/>
              <label for="select" className='me-2'> Instagram</label>
              <input type="checkbox" id="Facebook" name="Facebook" value="Facebook" className=' checkbox' onChange={(e)=>setInput({...input,[e.target.name]:e.target.value})}/>
              <label for="select" className='me-2'> Facebook</label>
              <input type="checkbox" id="LinkedIN" name="LinkedIN" value="LinkedIN" className=' checkbox' onChange={(e)=>setInput({...input,[e.target.name]:e.target.value})}/>
              <label for="select" className='me-2'> LinkedIN</label>
              <input type="checkbox" id="Youtube" name="Youtube" value="Youtube" className=' checkbox' onChange={(e)=>setInput({...input,[e.target.name]:e.target.value})}/>
              <label for="select" className='me-2'> Youtube</label>
              <input type="checkbox" id="durch Freunde" name="durch Freunde" value="durch Freunde" className=' checkbox' onChange={(e)=>setInput({...input,[e.target.name]:e.target.value})}/>
              <label for="select" className='me-2'> durch Freunde</label>
              <input type="checkbox" id="durch die Pii-Screens" name="durch die Pii-Screens" value="durch die Pii-Screens" className='checkbox' onChange={(e)=>setInput({...input,[e.target.name]:e.target.value})}/>
              <label for="select" className='me-2'> durch die Pii-Screens</label><br/>
              <button type='submit' className='btn btn-success my-5'>Senden</button>

             
             
            </form>
            </div>
       
        
        </div>
        </div>
        
    
    </>
  )
}
